export const USER_INIT_STATE = 'user/initState';
export const USER_GET_PROFILE = 'user/getCurrentProfile';
export const ARTIFACT_GET = 'artifact/getArtifact';
export const ARTIFACT_GET_FORCE = 'artifact/getArtifactForce';
export const ARTIFACT_INIT_STATE = 'artifact/initState';
export const ARTIFACT_GET_LAST_ARTIFACT = 'artifact/getLastArtifact';
